"use strict";

var _defineProperty = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$unitsPow;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var Units;

(function (Units) {
  Units["Wei"] = "Wei";
  Units["Kwei"] = "Kwei";
  Units["Mwei"] = "Mwei";
  Units["Gwei"] = "Gwei";
  Units["Szabo"] = "Szabo";
  Units["Finney"] = "Finney";
  Units["Ether"] = "Ether";
})(Units = exports.Units || (exports.Units = {}));

var base = new bn_js_1.default(10);
exports.unitsPow = (_exports$unitsPow = {}, _defineProperty(_exports$unitsPow, Units.Wei, new bn_js_1.default(1)), _defineProperty(_exports$unitsPow, Units.Kwei, base.pow(new bn_js_1.default(3))), _defineProperty(_exports$unitsPow, Units.Mwei, base.pow(new bn_js_1.default(6))), _defineProperty(_exports$unitsPow, Units.Gwei, base.pow(new bn_js_1.default(9))), _defineProperty(_exports$unitsPow, Units.Szabo, base.pow(new bn_js_1.default(12))), _defineProperty(_exports$unitsPow, Units.Finney, base.pow(new bn_js_1.default(15))), _defineProperty(_exports$unitsPow, Units.Ether, base.pow(new bn_js_1.default(18))), _exports$unitsPow);